"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var invariant_1 = __importDefault(require("invariant"));
var account_1 = require("../../account");
var currencies_1 = require("../../currencies");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
function formatAccountSpecifics(account) {
    var e_1, _a;
    var elrondResources = account.elrondResources;
    (0, invariant_1["default"])(elrondResources, "elrond account expected");
    var unit = (0, account_1.getAccountUnit)(account);
    var formatConfig = {
        disableRounding: true,
        alwaysShowSign: false,
        showCode: true
    };
    var str = " ";
    if (account.spendableBalance) {
        str +=
            (0, currencies_1.formatCurrencyUnit)(unit, account.spendableBalance, formatConfig) +
                " spendable. ";
    }
    else {
        str += " 0 spendable.";
    }
    if (elrondResources && elrondResources.nonce) {
        str += "\n  nonce : " + elrondResources.nonce;
    }
    if (elrondResources && elrondResources.delegations) {
        var delegated = new bignumber_js_1["default"](0);
        var undelegating = new bignumber_js_1["default"](0);
        var rewards = new bignumber_js_1["default"](0);
        try {
            for (var _b = __values(elrondResources.delegations), _c = _b.next(); !_c.done; _c = _b.next()) {
                var delegation = _c.value;
                delegated = delegated.plus(delegation.userActiveStake);
                undelegating = delegation.userUndelegatedList.reduce(function (sum, undelegation) { return sum.plus(undelegation.amount); }, undelegating);
                rewards = rewards.plus(delegation.claimableRewards);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        str +=
            delegated && delegated.gt(0)
                ? "\n  delegated: ".concat(unit ? (0, currencies_1.formatCurrencyUnit)(unit, delegated, formatConfig) : delegated)
                : undelegating && undelegating.gt(0)
                    ? "\n  undelegating: ".concat(unit
                        ? (0, currencies_1.formatCurrencyUnit)(unit, undelegating, formatConfig)
                        : undelegating)
                    : rewards && rewards.gt(0)
                        ? "\n  rewards: ".concat(unit ? (0, currencies_1.formatCurrencyUnit)(unit, rewards, formatConfig) : rewards)
                        : "";
    }
    return str;
}
function formatOperationSpecifics(op, unit) {
    var amount = op.extra.amount;
    return (amount === null || amount === void 0 ? void 0 : amount.gt) && amount.gt(0)
        ? " amount: " +
            "".concat(unit
                ? (0, currencies_1.formatCurrencyUnit)(unit, new bignumber_js_1["default"](amount), {
                    showCode: true,
                    disableRounding: true
                }).padEnd(16)
                : amount)
        : "";
}
exports["default"] = {
    formatAccountSpecifics: formatAccountSpecifics,
    formatOperationSpecifics: formatOperationSpecifics
};
//# sourceMappingURL=account.js.map